<template>
  <div class="container-fluid bg-secondary top-bar wow fadeIn" data-wow-delay="0.1s">
    <div class="row align-items-center h-100">
      <div class="col-lg-4 text-center text-lg-start">
        <a href="/" class="d-flex align-items-center">
          <!-- <img src="/img/logo.png" alt="Safari Strives Logo" style="max-height: 60px; width: auto;"> -->
          <h1 class="display-5 text-primary m-0">Safari Strives</h1>
        </a>
      </div>
      <div class="col-lg-8 d-none d-lg-block">
        <div class="row">
          <div class="col-lg-4">
            <div class="d-flex justify-content-end">
              <div class="flex-shrink-0 btn-square bg-primary">
                <i class="fa fa-phone-alt text-dark"></i>
              </div>
              <div class="ms-2">
                <h6 class="text-primary mb-0">Call Us</h6>
                <span class="text-black">US: +1 (331)-814-9549</span>
              </div>
            </div>
          </div>
          <div class="col-lg-4">
            <div class="d-flex justify-content-end">
              <div class="flex-shrink-0 btn-square bg-primary">
                <i class="fa fa-envelope-open text-dark"></i>
              </div>
              <div class="ms-2">
                <h6 class="text-primary mb-0">Mail Us</h6>
                <span class="text-black">contact@safaristrives.org</span>
              </div>
            </div>
          </div>
          <div class="col-lg-4">
            <div class="d-flex justify-content-end">
              <div class="flex-shrink-0 btn-square bg-primary">
                <i class="fa fa-map-marker-alt text-dark"></i>
              </div>
              <div class="ms-2">
                <h6 class="text-primary mb-0">Address</h6>
                <span class="text-black">4922 134th St, Crestwood, IL</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'TopbarView'
})
</script>
